export default __webpack_public_path__ + "static/media/icon-eye-open.d08fff69.svg";